/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ScheduleDetail_CustomerFragmentDoc, ScheduleDetail_ScheduleFragmentDoc } from '../../../../../../components/schedules/ScheduleDetail/__generated__/ScheduleDetail.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ScheduleDetailsPageQueryVariables = Types.Exact<{
  customerHandle: Types.Scalars['String'];
  scheduleId: Types.Scalars['ID'];
}>;


export type ScheduleDetailsPageQuery = { __typename: 'Query', customer?: { __typename: 'Customer', id: string, name: string, inputSources: Array<string>, displayCount: number, waveSubscriptionUsage?: number | null, playlists: Array<{ __typename: 'Playlist', id: string, title: string, playlistType: Types.PlaylistType }>, schedules: Array<{ __typename: 'Schedule', id: string }>, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null } | null, schedule?: { __typename: 'Schedule', id: string, title: string, description: string, isLegacy: boolean, isScheduleUsedByAnyConfiguration: boolean, timeBlocks: Array<{ __typename: 'ScheduleTimeBlock', day: Types.Day, start: string, end: string, type: Types.TimeBlockType, priority: number, category: Types.TimeBlockCategory, data: { __typename: 'ScheduleTimeBlockData', applicationId?: string | null, id?: string | null, mediaType?: string | null, source?: string | null, url?: string | null, value?: number | null } }>, allDisplays: Array<{ __typename: 'Display', id: string }>, syncedDisplays: Array<{ __typename: 'Display', id: string }>, outOfSyncDisplays: Array<{ __typename: 'Display', id: string }>, syncingDisplays: Array<{ __typename: 'Display', id: string }>, removingDisplays: Array<{ __typename: 'Display', id: string }> } | null, organization: { __typename: 'Organization', id: string, appSubscriptions: Array<{ __typename: 'OrganizationAppSubscription', id: string, applicationId: string, name: string }> } };


export const ScheduleDetailsPageDocument = gql`
    query ScheduleDetailsPage($customerHandle: String!, $scheduleId: ID!) {
  customer: customerByHandle(handle: $customerHandle) {
    id
    ...ScheduleDetail_customer
  }
  schedule(id: $scheduleId) {
    id
    ...ScheduleDetail_schedule
  }
  organization {
    id
    appSubscriptions {
      id
      applicationId
      name
    }
  }
}
    ${ScheduleDetail_CustomerFragmentDoc}
${ScheduleDetail_ScheduleFragmentDoc}`;

/**
 * __useScheduleDetailsPageQuery__
 *
 * To run a query within a React component, call `useScheduleDetailsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleDetailsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleDetailsPageQuery({
 *   variables: {
 *      customerHandle: // value for 'customerHandle'
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useScheduleDetailsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleDetailsPageQuery, ScheduleDetailsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleDetailsPageQuery, ScheduleDetailsPageQueryVariables>(ScheduleDetailsPageDocument, options);
      }
export function useScheduleDetailsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleDetailsPageQuery, ScheduleDetailsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleDetailsPageQuery, ScheduleDetailsPageQueryVariables>(ScheduleDetailsPageDocument, options);
        }
export type ScheduleDetailsPageQueryHookResult = ReturnType<typeof useScheduleDetailsPageQuery>;
export type ScheduleDetailsPageLazyQueryHookResult = ReturnType<typeof useScheduleDetailsPageLazyQuery>;
export type ScheduleDetailsPageQueryResult = ApolloReactCommon.QueryResult<ScheduleDetailsPageQuery, ScheduleDetailsPageQueryVariables>;